import { useMemo } from 'react';

import type { ShareActionsOptions } from 'src/app/shared/hooks/share';

import type { Channel } from './types';
import { useGetShareContent } from './useGetShareContent';
import { useGetShareTrackingData } from './useGetShareTrackingData';
import { useGetShareUrl } from './useGetShareUrl';

export function useShareOptions(): ShareActionsOptions<Channel> {
	const getUrl = useGetShareUrl();
	const getContent = useGetShareContent();
	const getTrackingData = useGetShareTrackingData();

	return useMemo(
		() => ({
			trackingEventName: 'share_dm_response',
			getUrl,
			getContent,
			getTrackingData,
		}),
		[getUrl, getContent, getTrackingData],
	);
}
